import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ApplicationAnswersHttpClient } from './application-answers.http-client';
import { ReferralsApplicationAnswersActions } from './application-answers.store';

@Injectable({ providedIn: 'root' })
export class ReferralsApplicationAnswersEffects {
  public effects = createEffectFactory(ReferralsApplicationAnswersActions, this.actions$);

  public loadReferralsAnswers$ = this.effects(
    ReferralsApplicationAnswersActions.fetchCollection,
    ({ payload }) =>
      this.http.loadApplicationAnswers(payload.candidateId).pipe(map(data => ({ data }))),
  );

  constructor(private http: ApplicationAnswersHttpClient, private actions$: Actions) {}
}
